import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

/**
 * Reactive access to a REdata feature flag (RED-242).
 *
 * Reads the `features` prop shared by HandleInertiaRequests, which already
 * holds the effective value for the current user (per-user override ?? global
 * switch). Mirrors the `auth.can[...]` idiom but is kept separate — feature
 * flags are not permissions.
 *
 * @param {string} key - the flag key from config/features.php
 * @returns {import('vue').ComputedRef<boolean>}
 */
export function useFeature(key) {
  return computed(() => usePage().props.features?.[key] ?? false)
}
